import React from 'react'
import ReactDOM from 'react-dom'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import WarningIcon from '@material-ui/icons/Warning'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import CloseIcon from '@material-ui/icons/Close'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { InnerHTML2React } from './element/InnerHTML2React'

$('.picture-as-pdf-icon').each((i, elem) => {
  ReactDOM.render(<PictureAsPdfIcon></PictureAsPdfIcon>, elem)
})

$('.open-in-new-icon').each((i, elem) => {
  ReactDOM.render(<OpenInNewIcon></OpenInNewIcon>, elem)
})

// 警告メッセージに自動的にアイコンを設定する
$('.alert.alert-warning, .alert.alert-danger').each((i, elem) => {
  if (!$(elem).hasClass('no-icon')) {
    ReactDOM.render(
      (
        <div className="d-flex align-items-center">
          <span className="warning-icon mr-2"></span>
          <div className='w-100'>
           {InnerHTML2React(elem.innerHTML)}
          </div>
        </div>
      ),
      elem
    )
  }
})
$('.warning-icon').each((i, elem) => {
  ReactDOM.render(<WarningIcon></WarningIcon>, elem)
  $(elem).addClass('align-bottom')
})

// 一般メッセージに自動的にアイコンを設定する
$('.alert.alert-primary, .alert.alert-success, .alert.alert-info').each((i, elem) => {
  if (!$(elem).hasClass('no-icon')) {
    ReactDOM.render(
      (
        <div className="d-flex align-items-center">
          <span className="info-icon mr-2"></span>
          <div>
            {InnerHTML2React(elem.innerHTML)}
          </div>
        </div>
      ),
      elem
    )
  }
})
$('.info-icon').each((i, elem) => {
  ReactDOM.render(<InfoOutlinedIcon></InfoOutlinedIcon>, elem)
  $(elem).addClass('align-bottom')
})

$('.close-icon').each((i, elem) => {
  ReactDOM.render(<CloseIcon></CloseIcon>, elem)
})

$('.arrow-right-icon').each((i, elem) => {
  ReactDOM.render(<ArrowRightIcon></ArrowRightIcon>, elem)
})
